import { settlementTexts } from 'consts/text';
import ParentHTTPService from 'services/HTTPService/parent/ParentHTTPService';
import { useAppQuery } from 'services/reactQuery/useAppQuery';

import { LoadingDisplay, ErrorDisplay, EmptyDisplay } from 'components/molecules';
import { ChildId } from 'types';
import { ChildSettlementComponents } from '../../ChildSettlementComponents/ChildSettlementComponents';

type Props = {
    period: string;
    childId: ChildId;
};

export const ParentSettlementMonthlyList = ({ period, childId }: Props) => {
    const {
        data: childSettlement,
        isLoading,
        isFetching,
        isError,
    } = useAppQuery(
        'CHILD_SETTLEMENT',
        [period, childId],
        () =>
            ParentHTTPService.settlements.getChildSettlement({
                period,
            }),
        {},
    );

    const monthlyDetails = childSettlement?.monthlySettlementDetailsDto;

    const renderContent = () => {
        if (isLoading || isFetching) return <LoadingDisplay />;
        if (isError) return <ErrorDisplay />;
        if (!monthlyDetails) return <EmptyDisplay />;

        return (
            <ChildSettlementComponents
                costComponentList={monthlyDetails.costComponentList}
                summary={monthlyDetails.grossSummary}
                title={settlementTexts.children.details.monthlySettlement}
            />
        );
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {renderContent()}
        </div>
    );
};
